import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'web-ui-components/lib/organisms/cards';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { SectionHeading } from 'web-ui-components/lib/molecules/text';

import { CommonShell } from '../common/CommonShell/CommonShell';
import AccountCardComponent from '../common/AccountCardComponent';
import { getCustomerNumberInfoText } from '../../businessLogic/AccountsBL';

const AccountSelectionComponent = ({
  alertLandingPageHeader,
  alertLandingPageInfo,
  alertLandingPageFooter,
  userPhoneNumber,
  validAccountList,
  onAccountClick,
  backClick,
  accountSelectionHeading,
  poundSign,
  alertSMELandingPageInfo,
  isCAUser,
}) => {
  const alertLandingPageContactNumberText = isCAUser
    ? alertSMELandingPageInfo
    : alertLandingPageInfo;
  return (
    <CommonShell backClick={backClick}>
      <PageHeading>Manage your alerts</PageHeading>
      <StandardBody>
        <p>{alertLandingPageHeader}</p>
      </StandardBody>
      <Card className="u-margin-bottom-2" type="info" bordered>
        {getCustomerNumberInfoText(alertLandingPageContactNumberText, userPhoneNumber)}
      </Card>
      <SectionHeading heading2={accountSelectionHeading}></SectionHeading>
      <AccountCardComponent
        poundSign={poundSign}
        accountData={validAccountList}
        onAccountClick={onAccountClick}
      />
      <StandardBody>
        <p>{alertLandingPageFooter}</p>
      </StandardBody>
    </CommonShell>
  );
};

AccountSelectionComponent.propTypes = {
  alertLandingPageHeader: PropTypes.string,
  alertLandingPageInfo: PropTypes.string,
  alertLandingPageFooter: PropTypes.string,
  validAccountList: PropTypes.array,
  userPhoneNumber: PropTypes.array,
  onAccountClick: PropTypes.func,
  getCustomerNumberInfoText: PropTypes.func,
  backClick: PropTypes.func,
  accountSelectionHeading: PropTypes.string,
  poundSign: PropTypes.string,
  alertSMELandingPageInfo: PropTypes.string,
  isCAUser: PropTypes.bool,
};

export default AccountSelectionComponent;
